export default "__VITE_ASSET__DYSbHKWj__"